import React, { FC } from 'react'
import styles from 'styles/components/line.module.scss'

type Props = {
  color?: 'black' | 'grey01' | 'grey02' | 'grey03' | 'grey04' | 'grey05'
  height?: number
  verticalMargin: number
}

const HorizontalLine: FC<Props> = (props) => {
  const { color = 'grey04', height, verticalMargin } = props
  const className = (() => {
    switch (color) {
      case 'black':
        return styles.horizontal_black
      case 'grey01':
        return styles.horizontal_grey01
      case 'grey02':
        return styles.horizontal_grey02
      case 'grey03':
        return styles.horizontal_grey03
      case 'grey04':
        return styles.horizontal_grey04
      case 'grey05':
        return styles.horizontal_grey05
      default:
        return styles.horizontal_grey04
    }
  })()
  return <hr className={className} style={{ height: `${height ?? 1}px`, margin: `${verticalMargin}px 0` }} />
}

export default HorizontalLine
